import { render, staticRenderFns } from "./DmDashboard.vue?vue&type=template&id=56667160&scoped=true&"
import script from "./DmDashboard.vue?vue&type=script&lang=js&"
export * from "./DmDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DmDashboard.vue?vue&type=style&index=0&id=56667160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56667160",
  null
  
)

export default component.exports